import React, { Component } from 'react'

export default class IconDownload extends Component {
  render() {
    return (
      <svg
        width="37"
        height="37"
      >
        <g
          transform="rotate(90 17.5 18.5)"
          fill="none"
          fillRule="evenodd"
        >
          <circle
            className="anim-stroke"
            stroke="#004178"
            cx="17.5"
            cy="17.5"
            r="17.5"
          />
          <path
            className="anim-stroke"
            d="M23.5 21.5v-9"
            stroke="#004178"
            strokeLinecap="square"
          />
          <path
            className="anim-fill"
            fill="#004178"
            d="M21 17l-8 5V12z"
          />
        </g>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/generic/IconDownload.js